import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Col } from 'react-bootstrap';
import { isObject as _isObject } from 'lodash';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormImageWithPreview from 'components/forms/FormImageWithPreview';

class WhiteLabelFavicons extends EntityPropsUpdater {
  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      entity,
      formStatusFavicon,
      formStatusFaviconIphone,
      formStatusFaviconIphoneRetina,
      formStatusFaviconIpad,
      formStatusFaviconIpadRetina,
      formStatusFaviconAndroid,
      formStatusFaviconMicrosoft,
      formStatusFaviconsAll,
      doNotify,
    } = this.props;

    if (prevProps.formStatusFavicon.pending && !formStatusFavicon.pending && !formStatusFavicon.hasError) {
      // image has been uploaded, update the entity
      const value = entity.createValue('favicon', [], formStatusFavicon.response);
      this.updateEntity('favicon', value, [], null, false);

      doNotify(1, messages.file_uploaded);
    }

    if (
      prevProps.formStatusFaviconIphone.pending &&
      !formStatusFaviconIphone.pending &&
      !formStatusFaviconIphone.hasError
    ) {
      // image has been uploaded, update the entity
      const value = entity.createValue('faviconIphone', [], formStatusFaviconIphone.response);
      this.updateEntity('faviconIphone', value, [], null, false);

      doNotify(1, messages.file_uploaded);
    }

    if (
      prevProps.formStatusFaviconIphoneRetina.pending &&
      !formStatusFaviconIphoneRetina.pending &&
      !formStatusFaviconIphoneRetina.hasError
    ) {
      // image has been uploaded, update the entity
      const value = entity.createValue('faviconIphoneRetina', [], formStatusFaviconIphoneRetina.response);
      this.updateEntity('faviconIphoneRetina', value, [], null, false);

      doNotify(1, messages.file_uploaded);
    }

    if (prevProps.formStatusFaviconIpad.pending && !formStatusFaviconIpad.pending && !formStatusFaviconIpad.hasError) {
      // image has been uploaded, update the entity
      const value = entity.createValue('faviconIpad', [], formStatusFaviconIpad.response);
      this.updateEntity('faviconIpad', value, [], null, false);

      doNotify(1, messages.file_uploaded);
    }

    if (
      prevProps.formStatusFaviconIpadRetina.pending &&
      !formStatusFaviconIpadRetina.pending &&
      !formStatusFaviconIpadRetina.hasError
    ) {
      // image has been uploaded, update the entity
      const value = entity.createValue('faviconIpadRetina', [], formStatusFaviconIpadRetina.response);
      this.updateEntity('faviconIpadRetina', value, [], null, false);

      doNotify(1, messages.file_uploaded);
    }

    if (
      prevProps.formStatusFaviconAndroid.pending &&
      !formStatusFaviconAndroid.pending &&
      !formStatusFaviconAndroid.hasError
    ) {
      // image has been uploaded, update the entity
      const value = entity.createValue('faviconAndroid', [], formStatusFaviconAndroid.response);
      this.updateEntity('faviconAndroid', value, [], null, false);

      doNotify(1, messages.file_uploaded);
    }

    if (
      prevProps.formStatusFaviconMicrosoft.pending &&
      !formStatusFaviconMicrosoft.pending &&
      !formStatusFaviconMicrosoft.hasError
    ) {
      // image has been uploaded, update the entity
      const value = entity.createValue('faviconMicrosoft', [], formStatusFaviconMicrosoft.response);
      this.updateEntity('faviconMicrosoft', value, [], null, false);

      doNotify(1, messages.file_uploaded);
    }

    // all favicon uploaded:
    if (prevProps.formStatusFaviconsAll.pending && !formStatusFaviconsAll.pending && !formStatusFaviconsAll.hasError) {
      // image has been uploaded, update the entity
      const favicon = entity.createValue('favicon', [], formStatusFaviconsAll.response.favicon);
      const faviconIphone = entity.createValue('faviconIphone', [], formStatusFaviconsAll.response.favicon_iphone);
      const faviconIphoneRetina = entity.createValue(
        'faviconIphoneRetina',
        [],
        formStatusFaviconsAll.response.favicon_iphone_retina
      );
      const faviconIpad = entity.createValue('faviconIpad', [], formStatusFaviconsAll.response.favicon_ipad);
      const faviconIpadRetina = entity.createValue(
        'faviconIpadRetina',
        [],
        formStatusFaviconsAll.response.favicon_ipad_retina
      );
      const faviconAndroid = entity.createValue('faviconAndroid', [], formStatusFaviconsAll.response.favicon_android);
      const faviconMicrosoft = entity.createValue(
        'faviconMicrosoft',
        [],
        formStatusFaviconsAll.response.favicon_microsoft
      );

      this.updateEntityMultiple(
        [
          'favicon',
          'faviconIphone',
          'faviconIphoneRetina',
          'faviconIpad',
          'faviconIpadRetina',
          'faviconAndroid',
          'faviconMicrosoft',
        ],
        [favicon, faviconIphone, faviconIphoneRetina, faviconIpad, faviconIpadRetina, faviconAndroid, faviconMicrosoft],
        [],
        null,
        false
      );

      doNotify(1, messages.file_uploaded);
    }
  };

  fileUpload = (name, images) => {
    if (_isObject(images) && images.length === 1) {
      const fd = new FormData();
      fd.append('file', images[0]);
      fd.append('faviconType', name);

      switch (name) {
        case 'faviconsAll':
          this.props.uploadFaviconsAll(this.props.entity.getId(), fd);
          break;

        case 'favicon':
          this.props.uploadFavicon(this.props.entity.getId(), fd);
          break;

        case 'faviconIphone':
          this.props.uploadFaviconIphone(this.props.entity.getId(), fd);
          break;

        case 'faviconIphoneRetina':
          this.props.uploadFaviconIphoneRetina(this.props.entity.getId(), fd);
          break;

        case 'faviconIpad':
          this.props.uploadFaviconIpad(this.props.entity.getId(), fd);
          break;

        case 'faviconIpadRetina':
          this.props.uploadFaviconIpadRetina(this.props.entity.getId(), fd);
          break;

        case 'faviconAndroid':
          this.props.uploadFaviconAndroid(this.props.entity.getId(), fd);
          break;

        case 'faviconMicrosoft':
          this.props.uploadFaviconMicrosoft(this.props.entity.getId(), fd);
          break;
      }
    }
  };

  fileReset = name => {
    this.updateEntity(name, null);
  };

  render() {
    const { entity, entityLoaded, disabled } = this.props;

    let faviconUrl;
    let faviconIphoneUrl;
    let faviconIphoneRetinaUrl;
    let faviconIpadUrl;
    let faviconIpadRetinaUrl;
    let faviconAndroidUrl;
    let faviconMicrosoftUrl;
    if (entityLoaded) {
      if (entity.getFavicon().getId()) {
        faviconUrl = entity.getFavicon().getWebLink();
      }

      if (entity.getFaviconIphone().getId()) {
        faviconIphoneUrl = entity.getFaviconIphone().getWebLink();
      }

      if (entity.getFaviconIphoneRetina().getId()) {
        faviconIphoneRetinaUrl = entity.getFaviconIphoneRetina().getWebLink();
      }

      if (entity.getFaviconIpad().getId()) {
        faviconIpadUrl = entity.getFaviconIpad().getWebLink();
      }

      if (entity.getFaviconIpadRetina().getId()) {
        faviconIpadRetinaUrl = entity.getFaviconIpadRetina().getWebLink();
      }

      if (entity.getFaviconAndroid().getId()) {
        faviconAndroidUrl = entity.getFaviconAndroid().getWebLink();
      }

      if (entity.getFaviconMicrosoft().getId()) {
        faviconMicrosoftUrl = entity.getFaviconMicrosoft().getWebLink();
      }
    }

    return entityLoaded ? (
      <React.Fragment>
        {!faviconUrl && (
          <Col xs={12} sm={4} className="m-b-20">
            <div className="form-group-attached">
              <FormImageWithPreview
                label="Favicon"
                name="faviconsAll"
                url={null}
                onChange={this.fileUpload}
                onReset={this.fileReset}
                pending={this.props.formStatusFaviconsAll.pending}
                disabled={disabled}
              />
            </div>
          </Col>
        )}

        {!!faviconUrl && (
          <React.Fragment>
            <Col xs={12} sm={4} className="m-b-20">
              <div className="form-group-attached">
                <FormImageWithPreview
                  label="Favicon"
                  name="favicon"
                  url={faviconUrl}
                  onChange={this.fileUpload}
                  onReset={this.fileReset}
                  pending={this.props.formStatusFavicon.pending}
                  disabled={disabled}
                />
              </div>
            </Col>

            <Col xs={12} sm={4} className="m-b-20">
              <div className="form-group-attached">
                <FormImageWithPreview
                  label="Favicon (iPhone)"
                  name="faviconIphone"
                  url={faviconIphoneUrl}
                  onChange={this.fileUpload}
                  onReset={this.fileReset}
                  pending={this.props.formStatusFaviconIphone.pending}
                  disabled={disabled}
                />
              </div>
            </Col>

            <Col xs={12} sm={4} className="m-b-20">
              <div className="form-group-attached">
                <FormImageWithPreview
                  label="Favicon (iPhone Retina)"
                  name="faviconIphoneRetina"
                  url={faviconIphoneRetinaUrl}
                  onChange={this.fileUpload}
                  onReset={this.fileReset}
                  pending={this.props.formStatusFaviconIphoneRetina.pending}
                  disabled={disabled}
                />
              </div>
            </Col>

            <Col xs={12} sm={4} className="m-b-20">
              <div className="form-group-attached">
                <FormImageWithPreview
                  label="Favicon (iPad)"
                  name="faviconIpad"
                  url={faviconIpadUrl}
                  onChange={this.fileUpload}
                  onReset={this.fileReset}
                  pending={this.props.formStatusFaviconIpad.pending}
                  disabled={disabled}
                />
              </div>
            </Col>

            <Col xs={12} sm={4} className="m-b-20">
              <div className="form-group-attached">
                <FormImageWithPreview
                  label="Favicon (iPad Retina)"
                  name="faviconIpadRetina"
                  url={faviconIpadRetinaUrl}
                  onChange={this.fileUpload}
                  onReset={this.fileReset}
                  pending={this.props.formStatusFaviconIpadRetina.pending}
                  disabled={disabled}
                />
              </div>
            </Col>

            <Col xs={12} sm={4} className="m-b-20">
              <div className="form-group-attached">
                <FormImageWithPreview
                  label="Favicon (Android)"
                  name="faviconAndroid"
                  url={faviconAndroidUrl}
                  onChange={this.fileUpload}
                  onReset={this.fileReset}
                  pending={this.props.formStatusFaviconAndroid.pending}
                  disabled={disabled}
                />
              </div>
            </Col>

            <Col xs={12} sm={4} className="m-b-20">
              <div className="form-group-attached">
                <FormImageWithPreview
                  label="Favicon (Microsoft)"
                  name="faviconMicrosoft"
                  url={faviconMicrosoftUrl}
                  onChange={this.fileUpload}
                  onReset={this.fileReset}
                  pending={this.props.formStatusFaviconMicrosoft.pending}
                  disabled={disabled}
                />
              </div>
            </Col>
          </React.Fragment>
        )}
      </React.Fragment>
    ) : null;
  }
}
WhiteLabelFavicons.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    formStatusFaviconsAll: state.formStatus.whiteLabelFaviconsAll,
    formStatusFavicon: state.formStatus.whiteLabelFavicon,
    formStatusFaviconIphone: state.formStatus.whiteLabelFaviconIphone,
    formStatusFaviconIphoneRetina: state.formStatus.whiteLabelFaviconIphoneRetina,
    formStatusFaviconIpad: state.formStatus.whiteLabelFaviconIpad,
    formStatusFaviconIpadRetina: state.formStatus.whiteLabelFaviconIpadRetina,
    formStatusFaviconAndroid: state.formStatus.whiteLabelFaviconAndroid,
    formStatusFaviconMicrosoft: state.formStatus.whiteLabelFaviconMicrosoft,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    uploadFaviconsAll: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelFaviconsAll',
        '/api/whitelabels/' + whiteLabelId + '/allfavicons.json',
        args,
        'post',
        dispatch
      );
    },
    uploadFavicon: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelFavicon',
        '/api/whitelabels/' + whiteLabelId + '/favicons.json',
        args,
        'post',
        dispatch
      );
    },
    uploadFaviconIphone: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelFaviconIphone',
        '/api/whitelabels/' + whiteLabelId + '/favicons.json',
        args,
        'post',
        dispatch
      );
    },
    uploadFaviconIphoneRetina: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelFaviconIphoneRetina',
        '/api/whitelabels/' + whiteLabelId + '/favicons.json',
        args,
        'post',
        dispatch
      );
    },
    uploadFaviconIpad: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelFaviconIpad',
        '/api/whitelabels/' + whiteLabelId + '/favicons.json',
        args,
        'post',
        dispatch
      );
    },
    uploadFaviconIpadRetina: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelFaviconIpadRetina',
        '/api/whitelabels/' + whiteLabelId + '/favicons.json',
        args,
        'post',
        dispatch
      );
    },
    uploadFaviconAndroid: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelFaviconAndroid',
        '/api/whitelabels/' + whiteLabelId + '/favicons.json',
        args,
        'post',
        dispatch
      );
    },
    uploadFaviconMicrosoft: (whiteLabelId, args) => {
      formStatusDispatchHelper(
        'whiteLabelFaviconMicrosoft',
        '/api/whitelabels/' + whiteLabelId + '/favicons.json',
        args,
        'post',
        dispatch
      );
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(WhiteLabelFavicons)
);
